module.exports = __webpack_public_path__ + "img/youtube-playables-01.11d6f8a1.webp";